export default "__VITE_ASSET__CbSAmiIw__"